/*
 * @Author: freedeng
 * @Date: 2019-06-24 21:41:29
 * @Last Modified by: freedeng
 * @Last Modified time: 2020-04-02 16:19:03
 */
var DocumentStatus = /** @class */ (function () {
    function DocumentStatus(options) {
        this.uid = options.uid;
        this.globalPadId = options.globalPadId;
        this.secretId = options.secretId;
        this.lastSyncTime = options.lastSyncTime || Date.now();
        this.lastErrorTime = options.lastErrorTime;
    }
    return DocumentStatus;
}());
export { DocumentStatus };
//# sourceMappingURL=DocumentStatus.js.map